/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect, useRef } from 'react';
import { useAnimation } from 'framer-motion6';
import PropTypes from 'prop-types';
import { ReactComponent as PlayIcon } from 'products/global/assets/img/join-us/play.svg';
import {
  CardContainer,
  Content,
  ContentWrapper,
  Footer,
  Image,
  StyledPin,
  VideoContainer,
  PlayButton
} from './styled';

const Card = ({
  name,
  location,
  description,
  photo,
  marginRight,
  isActiveCard,
  isDragging,
  type,
  video
}) => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  const contentWrapperControls = useAnimation();
  const [hasPlayed, setHasPlayed] = useState(false);
  const [playButtonIsHidden, setPlayButtonIsHidden] = useState(false);
  const videoRef = useRef();

  const showContent = () => {
    contentWrapperControls.start({
      y: 0,
      transition: { duration: 0.15, type: 'tween', ease: 'linear' }
    });
  };

  const hideContent = () => {
    contentWrapperControls.start({
      y: 'calc(100% - 60px)',
      transition: { duration: 0.15, type: 'tween', ease: 'linear' }
    });
  };

  const playVideo = () => {
    setHasPlayed(true);
    setPlayButtonIsHidden(true);
    videoRef?.current?.setAttribute('controls', 'controls');

    videoRef?.current?.play();
  };

  const pauseVideo = () => {
    setPlayButtonIsHidden(false);
  };

  useEffect(() => {
    if (isContentVisible && !isDragging && isActiveCard) {
      showContent();
    } else {
      hideContent();
    }
  }, [isContentVisible]);

  useEffect(() => {
    const video = videoRef?.current;
    setHasPlayed(false);

    if (video) {
      setPlayButtonIsHidden(false);
      video.pause();
      video.removeAttribute('controls');
      video.currentTime = 0;
    }

    if (!isActiveCard) {
      hideContent();
    }
  }, [isActiveCard]);

  return (
    <CardContainer
      onClick={() => setIsContentVisible(!isContentVisible)}
      marginRight={marginRight}
      isActiveCard={isActiveCard}
    >
      {type === 'video' ? (
        <>
          <VideoContainer>
            {!playButtonIsHidden && (
              <PlayButton onClick={() => playVideo()}>
                <PlayIcon />
              </PlayButton>
            )}
            {!hasPlayed && <Image fullHeight photo={photo} />}
            <video
              ref={videoRef}
              onPause={pauseVideo}
              onPlay={() => {
                setHasPlayed(true);
                setPlayButtonIsHidden(true);
              }}
            >
              <source src={video} type="video/mp4" />
            </video>
          </VideoContainer>
          <ContentWrapper
            animate={{ y: 'calc(100% - 60px)' }}
            transition={{ duration: 0.15, type: 'tween', ease: 'linear' }}
            $isPlaying={playButtonIsHidden}
          >
            <Footer>
              <h1>{name}</h1>
              <div>
                <StyledPin /> {location}
              </div>
            </Footer>
          </ContentWrapper>
        </>
      ) : (
        <>
          <Image photo={photo} />
          <ContentWrapper animate={contentWrapperControls}>
            <Footer>
              <h1>{name}</h1>
              <div>
                <StyledPin /> {location}
              </div>
            </Footer>
            <Content>{description}</Content>
          </ContentWrapper>
        </>
      )}
    </CardContainer>
  );
};

export default Card;

Card.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  marginRight: PropTypes.number.isRequired,
  photo: PropTypes.string.isRequired,
  isActiveCard: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired
};
